import { render, staticRenderFns } from "./AppointmentsDashboard.vue?vue&type=template&id=09a7272d&scoped=true&"
import script from "./AppointmentsDashboard.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsDashboard.vue?vue&type=style&index=0&id=09a7272d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a7272d",
  null
  
)

export default component.exports